<template>
  <div
    id="app"
    class="v-application v-application--is-ltr theme--light"
    data-app="true"
  >
    <router-view
      v-if="initializationFinished"
      :key="$route.fullPath"
    />
    <snack-bar />
  </div>
</template>

<script>
import SnackBar from '@/components/snack-bar/SnackBar'
import { reportLoadedSuccessfully } from 'sdk-widget-manager'
import { getClearFilters } from '@/store/ui/defaultFilters'
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'App',
  components: {
    'snack-bar': SnackBar
  },
  data: function () {
    return {
      initializationFinished: true,
      subscribedOnReInitEvent: false
    }
  },
  computed: {
    ...mapGetters({
      filters: 'ui/filters',
      initCount: 'ui/initCount',
      filterIsFilled: 'ui/filterIsFilled'
    }),
    currentPageKey () {
      return `${this.$route.fullPath}_${this.initCount}`
    }
  },
  mounted () {
    if (this.$useWidgetManager) {
      try {
        reportLoadedSuccessfully('websites.widgets.book-online-v4')
      } catch (_) {
        this.$ppAnalytics.trackEvent({ action: 'wm_report_error' })
      }
    }
    this.subscribeOnReInitEvent()
  },
  methods: {
    ...mapActions({
      setFormData: 'formData/setFormData',
      setFilters: 'ui/setFilters',
      increaseInitCount: 'ui/increaseInitCount'
    }),
    reInitApp (config = {}) {
      const locationId = config.locationId ? +config.locationId : null
      const providerId = config.providerId ? +config.providerId : null
      const appointmentTypeId = config.appointmentTypeId ? config.appointmentTypeId : null
      const notOnStepA = this.$route.name !== 'stepA'

      const locationChanged = locationId !== this.$locationIdFilter || (this.filterIsFilled('locationIdFilter') && +this.filters.locationIdFilter.value !== locationId)
      const providerChanged = providerId !== this.$providerIdFilter || (this.filterIsFilled('providerIdFilter') && +this.filters.providerIdFilter.value !== providerId)
      const appointmentTypeIdChanged = appointmentTypeId !== this.$appointmentTypeIdFilter || (this.filterIsFilled('appointmentReasonFilter') && +this.filters.appointmentReasonFilter.value !== appointmentTypeId)

      Vue.prototype.$locationIdFilter = locationId
      Vue.prototype.$providerIdFilter = providerId
      Vue.prototype.$appointmentTypeIdFilter = appointmentTypeId
      if (locationChanged || providerChanged || appointmentTypeIdChanged || notOnStepA) {
        this.initializationFinished = false
        if (locationChanged || providerChanged || appointmentTypeIdChanged) {
          this.setFilters(getClearFilters())
        }
        if (notOnStepA) {
          this.$router.replace({ name: 'stepA' })
        }
      }
      /* init count needs for 2 reasons
          * build correct key for router-view component and be sure and after re-init, whole app not using cached component view from previous initialisation
          * if nothing changes(user a on stepA, location and provider equal as in previous init), loaded ga(and datadog) event will be send to - there is a watcher inside stepA code
       */
      this.increaseInitCount()

      // increase init count on each reInit
      this.$nextTick(() => {
        this.initializationFinished = true
      })
    },
    subscribeOnReInitEvent () {
      if (this.subscribedOnReInitEvent) {
        return
      }
      this.subscribedOnReInitEvent = true
      window.addEventListener('message', (event) => {
        if (typeof event.data !== 'object' || !Object.prototype.hasOwnProperty.call(event.data, 'name') || event.data.name !== 'RE_INIT_SCHEDULING') {
          return
        }
        this.reInitApp(event.data.config)
      })
    }
  }
}
</script>

<style lang="scss">
html,
body {
  display: flex;
  flex: 1;
  max-width: 100vw;
  min-height: 100%;
}

body {
  .v-application {
    display: flex;
    flex: 1;
    line-height: 1.25;
    max-width: 100vw;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
